import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import type { StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import ContentBlock from '../_components/ContentBlock'

const useStyles = makeStyles<Theme, PeelNStickProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'PeelNStick' }
)

export interface PeelNStickProps {
  classes?: StyleClasses<typeof useStyles>
}

function PeelNStick(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentBlock
        imgFirst
        img={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/peel-and-stick-image.png'}
        preTitle="NEW"
        title={<>Peel & Stick</>}
        description={'No mess, no dry time. Try 8” x 8” samples.'}
        linkHref="https://samples.sherwin-williams.com/view/top-50-colors?_gl=1*ipru9e*_gcl_aw*R0NMLjE3MDk3Mzg0MzAuQ2p3S0NBaUFyZmF1QmhBcEVpd0Flb0I3cUFQSkozVXp1SjF4NlpDNFk1XzBTekJKMTNXcnl4Yy1PM3lMcGE2UXhOSXBmbG1JRl9YRHl4b0M5YXdRQXZEX0J3RQ..*_gcl_au*MTg3MzYxNTQwNy4xNzA1NTEwMjA2*_ga*MTkxMDU0MDU2MS4xNzAxNzIwOTM1*_ga_BFTFS1H2E0*MTcwOTgzMDQ2Ni45NC4xLjE3MDk4MzA1NDEuNTMuMC4w&_ga=2.44348844.941519321.1709664242-1910540561.1701720935&_gac=1.223506281.1709738716.CjwKCAiArfauBhApEiwAeoB7qAPJJ3UzuJ1x6ZC4Y5_0SzBJ13Wryxc-O3yLpa6QxNIpflmIF_XDyxoC9awQAvD_BwE"
        linkLabel="Order Now"
        backgroundColor="#EDEAE5"
      />
    </div>
  )
}

export default PeelNStick
